import BlockingPopup from './BlockingPopup';

export default BlockingPopup;
